import React, { useState } from 'react';
import axios from 'axios';

export default function CreateUser(){

    const [username, setUsername] = useState('');

    function onSubmit(e){
        const user = {
            username: username
        }
        console.log(user);

        axios.post('https://exercise-tracker5.herokuapp.com/users/add', user)
            .then(res => console.log(res.data))
            .catch(err => console.log(err));
        setUsername('');
    }

    return(
        <div className="CreateUser">
            <div className='usernamefield'>
                <label>Username: </label>
                <input type='name' value={username} onChange={(e)=>setUsername(e.target.value)} />
            </div>
            <div>
                <button onClick={onSubmit}>Create User</button>
            </div>
        </div>
    )
}
